import { Component, h, Prop, Watch, Method } from '@stencil/core';

interface UiCmsIframeBody {
  src: string;
  height: number;
  isAutoResized: boolean;
  isLowestElementActivated: boolean;
  isStrechtedOnNarrowViewport: boolean;
  isHiddenOnNarrowViewport: boolean;
  textOnHide: string;
  allowFullScreen: boolean;
  title: string;
}

@Component({
  tag: 'ui-cms-iframe',
  styleUrl: 'ui-cms-iframe.scss',
})
export class UiCmsIframe {
  @Prop({ mutable: true }) body: UiCmsIframeBody = {} as any;

  @Prop({ attribute: 'body' }) utilityBody: string;

  @Watch('utilityBody')
  utilityBodyChangeHandler(newValue: string) {
    this.body = newValue ? JSON.parse(newValue) : this.body;
  }

  private refIframe: HTMLIFrameElement;

  componentWillLoad() {
    this.utilityBodyChangeHandler(this.utilityBody);
  }

  /**
   * @param message e any message to be sent into the iframe
   * @description Send a message to the iframe
   * @example this.postMessageIntoIframe({ name: 'doSomething'; type: 'play' });
   */
  @Method() async postMessageIntoIframe(message: any) {
    this.refIframe.contentWindow.postMessage(message, '*');
  }

  componentDidLoad() {
    if (this.body.isAutoResized) {
      window.ui.services.iframe.initResizer(
        {
          log: false,
          heightCalculationMethod: this.body.isLowestElementActivated ? 'lowestElement' : 'bodyOffset',
        },
        this.refIframe
      );
    }
  }

  render() {
    return (
      <div
        class={{
          iframe: true,
          'iframe--hidden': this.body.isHiddenOnNarrowViewport,
        }}
      >
        <div class="iframe__wrapper">
          <iframe
            src={this.body.src}
            ref={(el) => {
              this.refIframe = el;
            }}
            width="100%"
            height={`${this.body.height || 600}px`}
            allowFullScreen={this.body.allowFullScreen}
            title={this.body.title}
          ></iframe>
        </div>
        <p class="sd-paragraph iframe__hiddentext">{this.body.textOnHide}</p>
      </div>
    );
  }
}
